import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import { Button, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import AddEditCompanyModal from '../../modals/companies/AddEditCompanyModal';
import { collectionKey } from '../../pages/InvestorsPage';

const useStyles = makeStyles((theme) => ({
    container: {
        width: 350,
        height: 180,
        border: `2px solid ${theme.colors.neutral['200']}`,
        borderRadius: 24,
        padding: 16,
    },
    headerIcon: {
        color: theme.colors.neutral['400'],
        width: 60,
        height: 60,
    },
    subText: {
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: 400,
        color: theme.colors.neutral['500'],
    },
    createButton: {
        width: '18ch',
        height: 40,
        borderRadius: 32,
        borderColor: theme.colors.neutral['100'],
        background: '#E0F1F1',
        color: theme.palette.primary.main,
        fontSize: '1rem',
        fontWeight: 'bold',
        textTransform: 'none',
        transition: 'ease-in-out 300ms',
    },
}));

const AddCompanyCard: React.FC<{}> = () => {
    const classes = useStyles();
    const [addCompanyModalOpen, setAddCompanyModalOpen] = useState<boolean>(false);

    return (<>
        <Stack className={classes.container} spacing={2} alignItems="center" justifyContent="center">
            <AddCircleRoundedIcon className={classes.headerIcon} />
            <Typography className={classes.subText}>
                {'Add manually'}
            </Typography>
            <Button variant="outlined"
                className={classes.createButton}
                startIcon={<AddCircleOutlineIcon />}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setAddCompanyModalOpen(true);
                }} disableRipple>{'Add company'} </Button>
        </Stack>
        {addCompanyModalOpen && (
            <AddEditCompanyModal
                isOpen={addCompanyModalOpen}
                collectionKey={collectionKey}
                onClose={() => setAddCompanyModalOpen(false)}
            />
        )}
    </>);
}

export default AddCompanyCard;